module.exports = __webpack_public_path__ + "static/img/home12.4e1ac8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home12.png
// module id = E50y
// module chunks = 13